import type { HookInitializeOutput } from '@terafile/shared'

/**
 * 暫定テナントセッションの localStorage 永続化。
 *
 * - キー: `tfb-ephemeral-session`
 * - 保存内容: `{ token, expiresAt, tenantId }`
 * - cookieId は HttpOnly Cookie 側で持つ（フロントから読まない）
 */

const KEY = 'tfb-ephemeral-session'

export type EphemeralSession = {
  token: string
  expiresAt: string
  tenantId: string
}

export function saveEphemeralSession(out: HookInitializeOutput): void {
  const sess: EphemeralSession = {
    token: out.ephemeralToken,
    expiresAt: out.expiresAt,
    tenantId: out.tenantId,
  }
  localStorage.setItem(KEY, JSON.stringify(sess))
}

export function loadEphemeralSession(): EphemeralSession | null {
  const raw = localStorage.getItem(KEY)
  if (!raw) return null
  try {
    const sess = JSON.parse(raw) as EphemeralSession
    if (new Date(sess.expiresAt).getTime() <= Date.now()) {
      clearEphemeralSession()
      return null
    }
    return sess
  } catch {
    return null
  }
}

/** Supabase セッションがある場合はお試しセッションを無効扱い（api.ts と同じ優先順位） */
export function getActiveEphemeralSession(hasSupabaseSession: boolean): EphemeralSession | null {
  if (hasSupabaseSession) return null
  return loadEphemeralSession()
}

export function clearEphemeralSession(): void {
  localStorage.removeItem(KEY)
}
